import React, { useEffect, useState } from "react";
import RightTimeApi from "@/API";
import { MdDelete } from "react-icons/md";
import { FaPlusSquare } from "react-icons/fa";
import GLAccountModal from "@modals/GLAccountModal";

const ACCOUNT_TYPE_LABELS = {
  0: "Asset",
  1: "Liability",
  2: "Equity",
  3: "Revenue",
  4: "Expense",
};

export default function GeneralLedgerTab({ isActive, updateSpinner }) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalError, setModalError] = useState(null);
  const [editAccount, setEditAccount] = useState(null);

  useEffect(() => {
    if (isActive) fetchAccounts();
  }, [isActive]);

  async function fetchAccounts() {
    setLoading(true);
    setError(null);
    try {
      const resp = await RightTimeApi.getAsync("/GL_Account");
      if (resp && resp.ok && resp.jsonData) {
        setAccounts(resp.jsonData);
      } else {
        setError("Failed to load GL accounts");
      }
    } catch (err) {
      setError("Error loading GL accounts");
    } finally {
      setLoading(false);
    }
  }

  // Placeholder for add/edit/delete handlers
  function handleAdd() {
    setEditAccount({ id: 0 });
    setShowModal(true);
    setModalError(null);
  }
  function handleEdit(account) {
    setEditAccount(account);
    setShowModal(true);
    setModalError(null);
  }

  function handleModalClose() {
    setShowModal(false);
    setEditAccount(null);
    setModalError(null);
    fetchAccounts(); // Refresh accounts after modal close
  }

  return (
    <>
        {error && <div className="formError">{error}</div>}
        <div className="tableWrapper dimensionTable scrollable glTable">
          <table>
            <caption>
              <span className="title">General Ledger Accounts
                </span><span className="actionIcon plusIcon captionRight" onClick={handleAdd} title="Add GL Account" >
                    <FaPlusSquare />
                </span>
            </caption>
            <thead>
              <tr>
                <th>Account Name</th>
                <th>Account #</th>
                <th>Description</th>
                <th>Type</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} className="center">Loading...</td></tr>
              ) : accounts.length === 0 ? (
                <tr><td colSpan={6} className="center">No GL accounts found</td></tr>
              ) : (
                accounts.map(account => (
                  <tr key={account.id} className="clickableRow" onClick={() => handleEdit(account)}>
                    <td>{account.accountName}</td>
                    <td>{account.id}</td>
                    <td>{account.description}</td>
                    <td>{account.categoryName}</td>
                    <td>
                      <span className={`status ${account.isActive ? 'active' : 'inactive'}`}>
                        {account.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
          <GLAccountModal
            isOpen={showModal}
            account={editAccount}
            onClose={handleModalClose}
            updateSpinner={updateSpinner}
          />
    </>
  );
}


